export const SEARCH_JENJANG_CHANGE = 'SEARCH_JENJANG_CHANGE';
export const SEARCH_TINGKAT_CHANGE = 'SEARCH_TINGKAT_CHANGE';
export const SEARCH_KELAS_CHANGE = 'SEARCH_KELAS_CHANGE';
export const SEARCH_PELAJARAN_CHANGE = 'SEARCH_PELAJARAN_CHANGE';
export const SEARCH_YEARS_CHANGE = 'SEARCH_YEARS_CHANGE';
export const SEARCH_SEMS_CHANGE = 'SEARCH_SEMS_CHANGE';
export const SEARCHFORM_DELETE = 'SEARCHFORM_DELETE';
